export const CaretDownIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:caret-down-small">
			<path id="Vector" d="M12.5 16.5L19.5 9.5H5.5L12.5 16.5Z" fill="#22082B" />
		</g>
	</svg>
);
